import { render, staticRenderFns } from "./Menu2.vue?vue&type=template&id=5e290f9d&scoped=true&"
import script from "./Menu2.vue?vue&type=script&lang=js&"
export * from "./Menu2.vue?vue&type=script&lang=js&"
import style0 from "./Menu2.vue?vue&type=style&index=0&id=5e290f9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e290f9d",
  null
  
)

export default component.exports